<template>
  <div class="instructions-container">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-10-desktop is-11-tablet">
          <div class="card">
            <header class="card-header">
              <div class="card-header-title is-block">
                <h1
                  class="title is-spaced is-size-3-desktop is-size-4-mobile has-text-weight-bold mb-2"
                >
                  Instrucciones
                </h1>
                <p
                  class="subtitle is-size-6-desktop is-size-6-mobile has-text-grey"
                >
                  Lee cuidadosamente antes de comenzar
                </p>
              </div>
            </header>

            <div class="card-content">
              <div class="content-wrapper">
                <p class="has-text-grey-dark">
                  Aquí encontrarás grupos de cuatro características (A, B, C,
                  D).
                </p>

                <div class="mt-4 mb-4">
                  <h3 class="has-text-weight-semibold is-size-5 mb-4">
                    Tu tarea es la siguiente:
                  </h3>

                  <div class="steps-list">
                    <div class="step-item">
                      <div class="step-number">
                        <span>1</span>
                      </div>
                      <div class="step-content">
                        <p class="has-text-weight-medium mb-1">
                          Lee las cuatro características (A, B, C, D).
                        </p>
                        <p class="is-size-7 has-text-grey-dark">
                          Usa los controles para asignar puntos a cada opción
                          según su importancia para ti
                        </p>
                      </div>
                    </div>

                    <div class="step-item">
                      <div class="step-number">
                        <span>2</span>
                      </div>
                      <div class="step-content">
                        <p class="has-text-weight-medium mb-1">
                          Distribuye 100 puntos entre ellas, según qué tan bien
                          describen a tu organización
                        </p>
                        <p class="is-size-7 has-text-grey-dark">
                          <strong>Más puntos</strong> = Característica que mejor
                          describe a tu organización &nbsp;|&nbsp;
                          <strong>Menos puntos</strong>
                          = Característica que la describe menos
                        </p>
                      </div>
                    </div>

                    <div class="step-item">
                      <div class="step-number">
                        <span>3</span>
                      </div>
                      <div class="step-content">
                        <p class="has-text-weight-medium mb-1">
                          Siempre la suma debe puntos debe ser igual a 100
                        </p>
                        <p class="is-size-7 has-text-grey-dark">
                          Pero debes garantizar que una de las opciones supere a
                          las demás al menos por 10 puntos.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <h3 class="has-text-weight-semibold is-size-5 mt-2">
                  Ejemplo
                </h3>
                <p class="has-text-grey-dark mt-2">
                  Si crees que la característica A describe muy bien a tu
                  organización, puedes asignarle 70 puntos, si B y C la
                  describen un poco puedes darles 15 puntos a cada una, y a la
                  D, 0 puntos porque no describe para nada tu organización. Esto
                  nos da un total de 100 puntos.
                </p>

                <div class="columns is-multiline mt-3">
                  <div class="column is-6-tablet is-12-mobile">
                    <div class="example-box is-success">
                      <div class="example-header">
                        <b-icon
                          icon="check-circle"
                          size="is-small"
                          type="is-success"
                        />
                        <h4 class="has-text-weight-semibold ml-2">Correcto</h4>
                      </div>
                      <div class="is-flex is-justify-content-space-between">
                        <p class="is-size-7 mt-2">
                          A. La organización es un lugar muy especial <br />
                          B. La organización es muy estricta<br />
                          C. La organización es muy creativa<br />
                          D. La organización siempre piensa en el cliente<br />
                        </p>
                        <p class="is-size-7 mt-2">
                          70<br />
                          15<br />
                          15<br />
                          0<br />
                        </p>
                      </div>
                    </div>
                  </div>

                  <div class="column is-6-tablet is-12-mobile">
                    <div class="example-box is-danger">
                      <div class="example-header">
                        <b-icon
                          icon="close-circle"
                          size="is-small"
                          type="is-danger"
                        />
                        <h4 class="has-text-weight-semibold ml-2">
                          No recomendable
                        </h4>
                      </div>
                      <div class="is-flex is-justify-content-space-between">
                        <p class="is-size-7 mt-2">
                          A. La organización es un lugar muy especial <br />
                          B. La organización es muy estricta<br />
                          C. La organización es muy creativa<br />
                          D. La organización siempre piensa en el cliente<br />
                        </p>
                        <p class="is-size-7 mt-2">
                          25<br />
                          25<br />
                          25<br />
                          25<br />
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <footer class="card-footer">
              <div class="card-footer-item">
                <b-button
                  type="is-primary"
                  size="is-medium"
                  expanded
                  @click="handleStart"
                >
                  Comenzar Encuesta
                </b-button>
              </div>
            </footer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Instructions",
  methods: {
    handleStart() {
      this.$emit("start");
    },
  },
};
</script>

<style scoped>
.instructions-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  background-color: #f5f5f5;
}

.card {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-header-title {
  padding: 1.5rem;
}

.card-content {
  padding: 1.5rem;
}

.content-wrapper {
  max-width: 100%;
}

/* Steps List */
.steps-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.step-item {
  display: flex;
  gap: 1rem;
  align-items: flex-start;
}

.step-number {
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background-color: #48c78e;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  flex-shrink: 0;
}

.step-content {
  flex: 1;
}

/* Example Boxes */
.example-box {
  padding: 1rem;
  border-radius: 6px;
  border: 1px solid;
}

.example-box.is-success {
  background-color: #effaf5;
  border-color: #48c78e;
}

.example-box.is-danger {
  background-color: #feecf0;
  border-color: #f14668;
}

.example-box.is-success h4 {
  color: #257953;
}

.example-box.is-danger h4 {
  color: #cc0f35;
}

.example-box.is-success p {
  color: #257953;
}

.example-box.is-danger p {
  color: #cc0f35;
}

.example-header {
  display: flex;
  align-items: center;
}

.card-footer-item {
  padding: 1.5rem;
  display: block;
}

/* Responsive */
@media screen and (max-width: 768px) {
  .instructions-container {
    padding: 1rem;
  }

  .card-header-title {
    padding: 1rem;
  }

  .card-content {
    padding: 1rem;
  }

  .title.is-3 {
    font-size: 1.5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/cultura/sections/survey/Instructions.vue